// rentDetailsConfig.js

import { Link } from '../components/shared';
import { checkNAOrReturnPercentValue, formatNumberOrReturnZero, rentTypeString } from '../utils/common-methods';
import { LEASE_DETAILS } from './accordionFields';

export const RENT_TYPES = [
  { value: 'FEE_ONLY', text: 'Fee Only' },
  { value: 'RATE_ONLY', text: 'Rate Only' },
  { value: 'FEE_PLUS_RATE', text: 'Fee Plus Rate' },
  { value: 'FEE_PLUS_RATE_COMBO', text: 'Fee Plus Rate Combo' },
  { value: 'FEE_PLUS_BREAKPOINT_RATE_MONTHLY', text: 'Fee Plus Breakpoint Rate - Monthly' },
  { value: 'FEE_PLUS_BREAKPOINT_RATE_TERM', text: 'Fee Plus Breakpoint Rate - Term' },
  { value: 'BREAKPOINT_RATE_TERM', text: 'Breakpoint Rate - Term' },
  { value: 'BREAKPOINT_RATE_TERM_COMBO', text: 'Breakpoint Rate - Term Combo' },
  { value: 'FEE_TERM_COMBO', text: 'Fee - Term Combo' },
  { value: 'RATE_ONLY_TIERED', text: 'Rate Only Tiered' },
  { value: 'RATE_ONLY_TIERED_TERM_COMBO', text: 'Rate Only Tiered - Term Combo' },
  { value: 'FEE_PLUS_TIERED_RATE', text: 'Fee Plus Tiered Rate' },
  { value: 'RATE_PLUS_BREAKPOINT_RATE_TERM', text: 'Rate Plus Breakpoint Rate - Term' },
  // Fee Plus Combo Rate - Term and Fee Plus Combo Rate - Monthly Rename to below rent types
  { value: 'FEE_PLUS_BREAKPOINT_RATE_MONTHLY_COMBO', text: 'Fee Plus Breakpoint Rate - Monthly Combo' },
  { value: 'FEE_PLUS_BREAKPOINT_RATE_TERM_COMBO', text: 'Fee Plus Breakpoint Rate - Term Combo' },
];

export const LEASE_COIN_COST_UNIT_OF_MEASURES = {
  DOLLAR: 'DOLLAR',
  PERCENTAGE: 'PERCENTAGE',
};

export const PRODUCT_CATEGORY = {
  GAME: {
    name: 'GAME',
    id: 36,
  },
  ARCADE: {
    name: 'ARCADE',
    id: 50,
  },
};

export const DYNAMICTEXTFIELDS = [
  { id: 1, name: 'Instant Win', rate: 0.0 },
  { id: 2, name: 'Redemption', rate: 0.0 },
  { id: 3, name: 'Video/Novelty', rate: 0.0 },
];

export const RENT_TYPE_CONFIG = {
  rentFee: [
    'FEE_ONLY',
    'FEE_PLUS_RATE',
    'FEE_PLUS_RATE_COMBO',
    'FEE_PLUS_BREAKPOINT_RATE_MONTHLY',
    'FEE_PLUS_BREAKPOINT_RATE_TERM',
    'FEE_PLUS_COMBO_RATE_MONTHLY',
    'FEE_PLUS_COMBO_RATE_TERM',
    'FEE_PLUS_TIERED_RATE',
    'FEE_PLUS_BREAKPOINT_RATE_MONTHLY_COMBO',
    'FEE_PLUS_BREAKPOINT_RATE_TERM_COMBO',
    'FEE_TERM_COMBO',
  ],
  rentRate: [
    'RATE_ONLY',
    'FEE_PLUS_RATE',
    'FEE_PLUS_RATE_COMBO',
    'FEE_PLUS_BREAKPOINT_RATE_MONTHLY',
    'RATE_PLUS_BREAKPOINT_RATE_TERM',
  ],
  breakpointRate: [
    'FEE_PLUS_BREAKPOINT_RATE_MONTHLY',
    'FEE_PLUS_BREAKPOINT_RATE_TERM',
    'FEE_PLUS_COMBO_RATE_MONTHLY',
    'FEE_PLUS_COMBO_RATE_TERM',
    'RATE_PLUS_BREAKPOINT_RATE_TERM',
    'BREAKPOINT_RATE_TERM',
    'BREAKPOINT_RATE_TERM_COMBO',
    'FEE_PLUS_BREAKPOINT_RATE_MONTHLY_COMBO',
    'FEE_PLUS_BREAKPOINT_RATE_TERM_COMBO',
  ],
  CAMFee: [
    'FEE_ONLY',
    'FEE_PLUS_RATE',
    'FEE_PLUS_RATE_COMBO',
    'BREAKPOINT_RATE_TERM',
    'BREAKPOINT_RATE_TERM_COMBO',
    'FEE_PLUS_BREAKPOINT_RATE_MONTHLY',
    'FEE_PLUS_BREAKPOINT_RATE_TERM',
    'FEE_PLUS_COMBO_RATE_MONTHLY',
    'FEE_PLUS_COMBO_RATE_TERM',
    'FEE_PLUS_TIERED_RATE',
    'RATE_ONLY',
    'RATE_ONLY_TIERED',
    'RATE_ONLY_TIERED_TERM_COMBO',
    'RATE_PLUS_BREAKPOINT_RATE_TERM',
    'FEE_PLUS_BREAKPOINT_RATE_MONTHLY_COMBO',
    'FEE_PLUS_BREAKPOINT_RATE_TERM_COMBO',
    'FEE_TERM_COMBO',
  ],
  CAMRate: [
    'FEE_ONLY',
    'RATE_ONLY',
    'FEE_PLUS_RATE',
    'FEE_PLUS_RATE_COMBO',
    'BREAKPOINT_RATE_TERM',
    'BREAKPOINT_RATE_TERM_COMBO',
    'FEE_PLUS_BREAKPOINT_RATE_MONTHLY',
    'FEE_PLUS_BREAKPOINT_RATE_TERM',
    'FEE_PLUS_COMBO_RATE_MONTHLY',
    'FEE_PLUS_COMBO_RATE_TERM',
    'RATE_ONLY_TIERED',
    'RATE_ONLY_TIERED_TERM_COMBO',
    'FEE_PLUS_TIERED_RATE',
    'RATE_PLUS_BREAKPOINT_RATE_TERM',
    'FEE_PLUS_BREAKPOINT_RATE_MONTHLY_COMBO',
    'FEE_PLUS_BREAKPOINT_RATE_TERM_COMBO',
    'FEE_TERM_COMBO',
  ],
  resetTerm: [
    'FEE_PLUS_BREAKPOINT_RATE_TERM',
    'FEE_PLUS_COMBO_RATE_TERM',
    'RATE_ONLY_TIERED',
    'RATE_ONLY_TIERED_TERM_COMBO',
    'BREAKPOINT_RATE_TERM',
    'FEE_PLUS_TIERED_RATE',
    'RATE_PLUS_BREAKPOINT_RATE_TERM',
    'BREAKPOINT_RATE_TERM_COMBO',
    'FEE_PLUS_BREAKPOINT_RATE_TERM_COMBO',
  ],
  payFrequency: [
    'FEE_PLUS_BREAKPOINT_RATE_TERM',
    'FEE_PLUS_COMBO_RATE_TERM',
    'RATE_ONLY_TIERED',
    'RATE_ONLY_TIERED_TERM_COMBO',
    'BREAKPOINT_RATE_TERM',
    'BREAKPOINT_RATE_TERM_COMBO',
    'FEE_PLUS_TIERED_RATE',
    'RATE_PLUS_BREAKPOINT_RATE_TERM',
    'FEE_PLUS_BREAKPOINT_RATE_TERM_COMBO',
    'FEE_TERM_COMBO',
  ],
  breakpointRevenue: [
    'FEE_PLUS_BREAKPOINT_RATE_MONTHLY',
    'FEE_PLUS_BREAKPOINT_RATE_TERM',
    'FEE_PLUS_COMBO_RATE_MONTHLY',
    'FEE_PLUS_COMBO_RATE_TERM',
    'BREAKPOINT_RATE_TERM',
    'BREAKPOINT_RATE_TERM_COMBO',
    'RATE_PLUS_BREAKPOINT_RATE_TERM',
    'FEE_PLUS_BREAKPOINT_RATE_MONTHLY_COMBO',
    'FEE_PLUS_BREAKPOINT_RATE_TERM_COMBO',
  ],
  dynamicTextFields: ['RATE_ONLY', 'FEE_PLUS_RATE', 'FEE_PLUS_BREAKPOINT_RATE_MONTHLY', 'FEE_PLUS_COMBO_RATE_MONTHLY'],
  tierBreakpointAndRate: ['RATE_ONLY_TIERED', 'RATE_ONLY_TIERED_TERM_COMBO', 'FEE_PLUS_TIERED_RATE'],
};

export const RENT_TYPE_GROUPS = {
  TIERED: ['RATE_ONLY_TIERED', 'RATE_ONLY_TIERED_TERM_COMBO', 'FEE_PLUS_TIERED_RATE'],
  REQUIRES_RENT_FEE: [
    'FEE_ONLY',
    'FEE_PLUS_RATE',
    'FEE_PLUS_BREAKPOINT_RATE_MONTHLY',
    'FEE_PLUS_BREAKPOINT_RATE_TERM',
    'FEE_PLUS_COMBO_RATE_MONTHLY',
    'FEE_PLUS_COMBO_RATE_TERM',
    'FEE_PLUS_TIERED_RATE',
    'FEE_PLUS_RATE_COMBO',
    'FEE_TERM_COMBO',
    'FEE_PLUS_BREAKPOINT_RATE_MONTHLY_COMBO',
    'FEE_PLUS_BREAKPOINT_RATE_TERM_COMBO',
  ],
  REQUIRES_RENT_RATE: ['RATE_ONLY', 'FEE_PLUS_RATE', 'RATE_PLUS_BREAKPOINT_RATE_TERM', 'FEE_PLUS_RATE_COMBO'],
  REQUIRES_RESET_TERM: [
    'FEE_PLUS_BREAKPOINT_RATE_TERM',
    'FEE_PLUS_COMBO_RATE_TERM',
    'RATE_ONLY_TIERED',
    'RATE_ONLY_TIERED_TERM_COMBO',
    'FEE_PLUS_TIERED_RATE',
    'RATE_PLUS_BREAKPOINT_RATE_TERM',
    'BREAKPOINT_RATE_TERM',
    'BREAKPOINT_RATE_TERM_COMBO',
    'FEE_PLUS_BREAKPOINT_RATE_TERM_COMBO',
  ],
  REQUIRES_PAY_FREQUENCY: [
    'FEE_PLUS_BREAKPOINT_RATE_TERM',
    'FEE_PLUS_COMBO_RATE_TERM',
    'RATE_ONLY_TIERED',
    'RATE_ONLY_TIERED_TERM_COMBO',
    'FEE_PLUS_TIERED_RATE',
    'RATE_PLUS_BREAKPOINT_RATE_TERM',
    'BREAKPOINT_RATE_TERM',
    'BREAKPOINT_RATE_TERM_COMBO',
    'FEE_TERM_COMBO',
    'FEE_PLUS_BREAKPOINT_RATE_TERM_COMBO',
  ],
  REQUIRES_BREAKPOINT_REVENUE: [
    'FEE_PLUS_BREAKPOINT_RATE_MONTHLY',
    'FEE_PLUS_BREAKPOINT_RATE_TERM',
    'FEE_PLUS_COMBO_RATE_MONTHLY',
    'FEE_PLUS_COMBO_RATE_TERM',
    'RATE_PLUS_BREAKPOINT_RATE_TERM',
    'BREAKPOINT_RATE_TERM',
    'BREAKPOINT_RATE_TERM_COMBO',
    'FEE_PLUS_BREAKPOINT_RATE_MONTHLY_COMBO',
    'FEE_PLUS_BREAKPOINT_RATE_TERM_COMBO',
  ],
  REQUIRES_BREAKPOINT_RATE: [
    'FEE_PLUS_BREAKPOINT_RATE_MONTHLY',
    'FEE_PLUS_BREAKPOINT_RATE_TERM',
    'FEE_PLUS_COMBO_RATE_MONTHLY',
    'FEE_PLUS_COMBO_RATE_TERM',
    'RATE_PLUS_BREAKPOINT_RATE_TERM',
    'BREAKPOINT_RATE_TERM',
    'BREAKPOINT_RATE_TERM_COMBO',
    'FEE_PLUS_BREAKPOINT_RATE_MONTHLY_COMBO',
    'FEE_PLUS_BREAKPOINT_RATE_TERM_COMBO',
  ],
};

const { RENT } = LEASE_DETAILS;
const isValidURL = (url) => {
  try {
    new URL(url);
    return true;
  } catch (e) {
    return false;
  }
};

export const getContractLink = (url) => {
  const lowerCaseUrl = typeof url === 'string' ? url.toLowerCase() : '';
  if (isValidURL(lowerCaseUrl)) {
    return (
      <Link
        underline="hover"
        to={lowerCaseUrl}
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          color: '#1976D2',
          textTransform: 'lowercase',
          overflowWrap: 'break-word',
          wordWrap: 'break-word',
          wordBreak: 'break-all',
          display: 'inline-block',
          maxWidth: '100%',
        }}
      >
        {lowerCaseUrl}
      </Link>
    );
  }
  return lowerCaseUrl || '';
};

const tierSummaryDetails = (tierSummary) => {
  if (!Array.isArray(tierSummary) || tierSummary.length === 0) return [];

  const summaryParts = tierSummary.map((tier, index) => {
    const rawThreshold = tier.tierThreshold?.toString().replace(/,/g, '');
    const thresholdBeforeDecimal = rawThreshold?.split('.')[0];
    const thresholdValue = Number(rawThreshold).toFixed(2);
    const rate = `${(parseFloat(tier.tierRate) * 100)?.toFixed(2)}%`;

    const isLastTier = index === tierSummary.length - 1;

    const isUnlimited = isLastTier && thresholdBeforeDecimal?.length > 7;

    if (isUnlimited) {
      return (
        <span key={index}>
          additional revenue is paid at <strong>{rate}</strong>
        </span>
      );
    }

    const formattedThreshold = `$${thresholdValue.toLocaleString(undefined, {
      maximumFractionDigits: 0,
    })}`;

    return (
      <span key={index}>
        Net Revenue up to <strong>{formattedThreshold}</strong> is paid at <strong>{rate}</strong>
      </span>
    );
  });

  return [
    {
      label: 'Tier Summary',
      value: summaryParts.reduce((prev, curr, i) => (
        <>
          {prev}
          {i > 0 && ', then '}
          {curr}
        </>
      )),
    },
  ];
};

export const rentDetailsCommonrentType = (leaseDetails) => [
  { label: RENT.RENT_TYPE, value: rentTypeString(leaseDetails?.rentType) },
];
export const rentDetailsCommon = (leaseDetails) => [
  {
    label: RENT.RENT_OPTIONS,
    value:
      leaseDetails?.contractRentOptions
        ?.map((cro) => cro?.rentOption?.name)
        .filter(Boolean)
        .join(', ') || 'N/A',
  },
  {
    label: RENT.CAM_FEE,
    value: `$${formatNumberOrReturnZero(leaseDetails?.CAMFee)}`,
  },
  {
    label: RENT.CAM_RATE,
    value: checkNAOrReturnPercentValue(leaseDetails?.CAMRate),
  },
  {
    label: RENT.COIN_COST,
    value:
      leaseDetails?.coinCostUom === LEASE_COIN_COST_UNIT_OF_MEASURES.PERCENTAGE
        ? `${formatNumberOrReturnZero(leaseDetails?.coinCost)}%`
        : `$${formatNumberOrReturnZero(leaseDetails?.coinCost)}`,
  },
  {
    label: RENT.CC_DEFAULT_RATE,
    value: checkNAOrReturnPercentValue(leaseDetails?.creditCardFeeRate),
  },
  {
    label: RENT.CARD_COST,
    value: `$${formatNumberOrReturnZero(leaseDetails?.cardCost)}`,
  },
  {
    label: RENT.CONTRACT_Link,
    value: leaseDetails?.contractLink && getContractLink(leaseDetails?.contractLink),
  },
  {
    label: RENT.NOTES,
    value: leaseDetails?.notes && `${leaseDetails?.notes}`,
  },
];

const generateDynamicLabels = (modelTypes) =>
  modelTypes?.map((value) => ({
    label: value?.gameCategory?.name,
    value: `${value?.rentRate}`,
  }));
export const rentDetailsFields = (type, leaseDetails) => {
  switch (type) {
    case 'FEE_ONLY':
      return [
        ...rentDetailsCommonrentType(leaseDetails),
        {
          label: RENT.RENT_FEE,
          value: `$${formatNumberOrReturnZero(leaseDetails?.fee)}`,
        },
        ...rentDetailsCommon(leaseDetails), // Pass common leaseDetails here
      ];
    case 'RATE_ONLY':
      return [
        ...rentDetailsCommonrentType(leaseDetails),
        {
          label: RENT.RENT_RATE,
          value: checkNAOrReturnPercentValue(leaseDetails?.rate),
        },
        ...rentDetailsCommon(leaseDetails), // Pass leaseDetails here
      ];
    case 'FEE_PLUS_RATE':
      return [
        ...rentDetailsCommonrentType(leaseDetails),
        {
          label: RENT.RENT_FEE,
          value: `$${formatNumberOrReturnZero(leaseDetails?.fee)}`,
        },
        {
          label: RENT.RENT_RATE,
          value: checkNAOrReturnPercentValue(leaseDetails?.rate),
        },
        ...rentDetailsCommon(leaseDetails), // Pass leaseDetails here
      ];
    case 'FEE_PLUS_RATE_COMBO':
      return [
        ...rentDetailsCommonrentType(leaseDetails),
        {
          label: RENT.RENT_FEE,
          value: `$${formatNumberOrReturnZero(leaseDetails?.fee)}`,
        },
        {
          label: RENT.RENT_RATE,
          value: checkNAOrReturnPercentValue(leaseDetails?.rate),
        },
        ...rentDetailsCommon(leaseDetails), // Pass leaseDetails here
      ];
    case 'FEE_PLUS_BREAKPOINT_RATE_MONTHLY':
      return [
        ...rentDetailsCommonrentType(leaseDetails),
        {
          label: RENT.RENT_FEE,
          value: `$${formatNumberOrReturnZero(leaseDetails?.fee)}`,
        },
        {
          label: RENT.BREAKPOINT_VALUE,
          value: leaseDetails?.breakpointRevenue ? `$${leaseDetails?.breakpointRevenue}` : '',
        },
        {
          label: RENT.BREAKPOINT_RATE,
          value: checkNAOrReturnPercentValue(leaseDetails?.breakpointRate),
        },
        ...rentDetailsCommon(leaseDetails),
      ];
    case 'FEE_PLUS_BREAKPOINT_RATE_TERM':
      return [
        ...rentDetailsCommonrentType(leaseDetails),
        {
          label: RENT.RENT_FEE,
          value: `$${formatNumberOrReturnZero(leaseDetails?.fee)}`,
        },
        {
          label: RENT.RESET_TERM,
          value: leaseDetails?.resetTerm ? leaseDetails?.resetTerm : '',
        },
        {
          label: RENT.PAY_FREQUENCY,
          value: leaseDetails?.payFrequency ? leaseDetails?.payFrequency : '',
        },
        {
          label: RENT.BREAKPOINT_VALUE,
          value: leaseDetails?.breakpointRevenue ? `$${leaseDetails?.breakpointRevenue}` : '',
        },
        {
          label: RENT.BREAKPOINT_RATE,
          value: checkNAOrReturnPercentValue(leaseDetails?.breakpointRate),
        },
        ...rentDetailsCommon(leaseDetails),
      ];
    case 'BREAKPOINT_RATE_TERM':
      return [
        ...rentDetailsCommonrentType(leaseDetails),
        {
          label: RENT.RESET_TERM,
          value: leaseDetails?.resetTerm ? leaseDetails?.resetTerm : '',
        },
        {
          label: RENT.PAY_FREQUENCY,
          value: leaseDetails?.payFrequency ? leaseDetails?.payFrequency : '',
        },
        {
          label: RENT.BREAKPOINT_VALUE,
          value: leaseDetails?.breakpointRevenue ? `$${leaseDetails?.breakpointRevenue}` : '',
        },
        {
          label: RENT.BREAKPOINT_RATE,
          value: checkNAOrReturnPercentValue(leaseDetails?.breakpointRate),
        },
        ...rentDetailsCommon(leaseDetails),
      ];
    case 'BREAKPOINT_RATE_TERM_COMBO':
      return [
        ...rentDetailsCommonrentType(leaseDetails),
        {
          label: RENT.RESET_TERM,
          value: leaseDetails?.resetTerm ? leaseDetails?.resetTerm : '',
        },
        {
          label: RENT.PAY_FREQUENCY,
          value: leaseDetails?.payFrequency ? leaseDetails?.payFrequency : '',
        },
        {
          label: RENT.BREAKPOINT_VALUE,
          value: leaseDetails?.breakpointRevenue ? `$${leaseDetails?.breakpointRevenue}` : '',
        },
        {
          label: RENT.BREAKPOINT_RATE,
          value: checkNAOrReturnPercentValue(leaseDetails?.breakpointRate),
        },
        ...rentDetailsCommon(leaseDetails),
      ];
    case 'FEE_PLUS_BREAKPOINT_RATE_MONTHLY_COMBO':
      return [
        ...rentDetailsCommonrentType(leaseDetails),
        {
          label: RENT.RENT_FEE,
          value: `$${formatNumberOrReturnZero(leaseDetails?.fee)}`,
        },
        {
          label: RENT.BREAKPOINT_VALUE,
          value: leaseDetails?.breakpointRevenue ? `$${leaseDetails?.breakpointRevenue}` : '',
        },
        {
          label: RENT.BREAKPOINT_RATE,
          value: checkNAOrReturnPercentValue(leaseDetails?.breakpointRate),
        },
        ...rentDetailsCommon(leaseDetails),
      ];
    case 'FEE_PLUS_BREAKPOINT_RATE_TERM_COMBO':
      return [
        ...rentDetailsCommonrentType(leaseDetails),
        {
          label: RENT.RENT_FEE,
          value: `$${formatNumberOrReturnZero(leaseDetails?.fee)}`,
        },
        {
          label: RENT.RESET_TERM,
          value: leaseDetails?.resetTerm ? leaseDetails?.resetTerm : '',
        },
        {
          label: RENT.PAY_FREQUENCY,
          value: leaseDetails?.payFrequency ? leaseDetails?.payFrequency : '',
        },
        {
          label: RENT.BREAKPOINT_VALUE,
          value: leaseDetails?.breakpointRevenue ? `$${leaseDetails?.breakpointRevenue}` : '',
        },
        {
          label: RENT.BREAKPOINT_RATE,
          value: checkNAOrReturnPercentValue(leaseDetails?.breakpointRate),
        },
        ...rentDetailsCommon(leaseDetails),
      ];
    case 'FEE_TERM_COMBO':
      return [
        ...rentDetailsCommonrentType(leaseDetails),
        {
          label: RENT.RENT_FEE,
          value: `$${formatNumberOrReturnZero(leaseDetails?.fee)}`,
        },
        {
          label: RENT.RESET_TERM,
          value: leaseDetails?.resetTerm ? leaseDetails?.resetTerm : '',
        },
        {
          label: RENT.PAY_FREQUENCY,
          value: leaseDetails?.payFrequency ? leaseDetails?.payFrequency : '',
        },
        ...rentDetailsCommon(leaseDetails),
      ];
    case 'RATE_ONLY_TIERED':
    case 'RATE_ONLY_TIERED_TERM_COMBO':
      return [
        ...rentDetailsCommonrentType(leaseDetails),
        {
          label: RENT.RENT_RATE,
          value: checkNAOrReturnPercentValue(leaseDetails?.rate),
        },
        {
          label: RENT.RESET_TERM,
          value: leaseDetails?.resetTerm ? leaseDetails?.resetTerm : '',
        },
        {
          label: RENT.PAY_FREQUENCY,
          value: leaseDetails?.payFrequency ? leaseDetails?.payFrequency : '',
        },
        ...rentDetailsCommon(leaseDetails),
        ...tierSummaryDetails(leaseDetails.tierSummary),
      ];
    case 'FEE_PLUS_TIERED_RATE':
      return [
        ...rentDetailsCommonrentType(leaseDetails),
        {
          label: RENT.RENT_FEE,
          value: `$${formatNumberOrReturnZero(leaseDetails?.fee)}`,
        },
        {
          label: RENT.RESET_TERM,
          value: leaseDetails?.resetTerm ? leaseDetails?.resetTerm : '',
        },
        {
          label: RENT.PAY_FREQUENCY,
          value: leaseDetails?.payFrequency ? leaseDetails?.payFrequency : '',
        },
        ...rentDetailsCommon(leaseDetails),
        ...tierSummaryDetails(leaseDetails.tierSummary),
      ];
    case 'RATE_PLUS_BREAKPOINT_RATE_TERM':
      return [
        ...rentDetailsCommonrentType(leaseDetails),
        {
          label: RENT.RENT_RATE,
          value: checkNAOrReturnPercentValue(leaseDetails?.rate),
        },
        {
          label: RENT.RESET_TERM,
          value: leaseDetails?.resetTerm ? leaseDetails?.resetTerm : '',
        },
        {
          label: RENT.PAY_FREQUENCY,
          value: leaseDetails?.payFrequency ? leaseDetails?.payFrequency : '',
        },
        {
          label: RENT.BREAKPOINT_RATE,
          value: checkNAOrReturnPercentValue(leaseDetails?.breakpointRate),
        },
        ...rentDetailsCommon(leaseDetails),
      ];
    case 'BENCHMARK_RENT':
      return [
        ...rentDetailsCommon(leaseDetails),
        ...generateDynamicLabels(leaseDetails?.contractAssetGameCategoryRates),
      ];
    default:
      return [...rentDetailsCommon(leaseDetails)];
  }
};
